import { FC, useState } from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { Page } from '../../types/Page';
import { Storefront } from '@mui/icons-material';
import { moreMenu } from '../../hooks/useNavigationMenu';
import { Grid } from '@mui/material';

interface Props {
  showPanel: boolean;
  onVisibilityChange: (isVisible: boolean) => void
  pages: Page[];
  selectedPage: number;
  onClick: (path: string) => void;
}
export const BottomBar: FC<Props> = ({pages, selectedPage, showPanel, onVisibilityChange, onClick}) => {
  const [, setValue] = useState(0);

  return (
    <Grid container sx={{position: 'fixed', bottom: '0px',  width: '100%', zIndex:1, display: { md: "none" }, justifyContent: 'center', background: 'white'}}>
      <BottomNavigation
        showLabels
        value={selectedPage}  
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={{  width: '90%'}} 
      >
          
        {
          pages.map(p => <BottomNavigationAction sx={{minWidth: '40px'}}  label={p.label} icon={p.Icon} key={p.label} onClick={() => onClick(p.path)} />)
        }

        <BottomNavigationAction label={moreMenu} icon={<Storefront />} onClick={() => onVisibilityChange(true)} />
        
      </BottomNavigation>
    </Grid>
  );
}